import {HttpClient, RequestParams} from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICategoryCharityQuery} from "../../models/category_charity/query";
import {ICategoryCharity, ICategoryCharityDetails} from "../../models/category_charity/response";
import {IInvestor, IInvestorDetails} from "../../models/investor/response";
import {ICreateInvestor, IUpdateInvestor} from "../../models/investor/request";
import {ICreateCategoryCharity, IUpdateCategoryCharity} from "../../models/category_charity/request";

class CategoryCharityService<SecurityDataType = unknown> {
    http: HttpClient<SecurityDataType>;

    constructor(http: HttpClient<SecurityDataType>) {
        this.http = http;
    }

    getAllCategoriesCharities = (query: ICategoryCharityQuery, params?: RequestParams) =>
        this.http.request<IBaseListingResponse<ICategoryCharity>>({
            path: `/category-charity`,
            method: "GET",
            query,
            ...params,
        });

    getCategoryCharity = (id: number, params?: RequestParams) =>
        this.http.request<ICategoryCharityDetails>({
            path: `/category-charity/${id}`,
            method: "GET",
            ...params,
        });

    createCategoryCharity = (data: ICreateCategoryCharity, params?: RequestParams) =>
        this.http.request<ICategoryCharity>({
            path: "/category-charity",
            method: "POST",
            body: data,
            ...params,
        });

    updateCategoryCharity = (
        id: number,
        data: IUpdateCategoryCharity,
        params?: RequestParams
    ) =>
        this.http.request<ICategoryCharity>({
            path: `/category-charity/${id}`,
            method: "PUT",
            body: data,
            ...params,
        });

    deleteCategoryCharity = (id: number, params?: RequestParams) =>
        this.http.request<ICategoryCharity>({
            path: `/category-charity/${id}`,
            method: "DELETE",
            ...params,
        });

}

export default CategoryCharityService;
